import {Product, VendingOccupancyContent} from "../types";
import * as React from "react";
import {useCallback, useState} from "react";
import {
    BoxTypeSelection,
    BoxTypeSelectionResult,
    classNames,
    layout,
    MessageView,
    PendingView,
    PushButton,
    typography,
    useAsync,
    useBoxes,
    usePlatform,
    View,
    ViewContent,
    ViewHeader,
    ViewTitle
} from "@variocube/cube-ui";
import {getBoxTypes} from "@variocube/app-common";
import {StorageBoxAccess} from "./StorageBoxAccess";
import {AccessCodeAlphabet} from "@variocube/app-api";
import {useLocalization} from "../../i18n";


export interface AdminStoreProductFlowProps {
    product: Product;
    onDone: () => void;
}

export function AdminStoreProductFlow({product, onDone}: AdminStoreProductFlowProps) {
    const [boxSelection, setBoxSelection] = useState<BoxTypeSelectionResult>();
    const {t} = useLocalization();
    const boxes = useBoxes();
    const platform = usePlatform();

    const {error, loading, result: occupancy} = useAsync(async () => {
        if (!boxSelection) {
            return undefined;
        }
        const content: VendingOccupancyContent = {
            product: product.id
        };
        return await platform.occupy({
            ...boxSelection,
            content,
            accessCodeShape: {
                alphabet: AccessCodeAlphabet.OneToNine,
                length: 5
            },
        });
    }, [platform, product, boxSelection]);

    const box = boxes.find(box => box.number == occupancy?.boxNumber);
    const handleOtherTypeClick = useCallback(() => setBoxSelection(undefined), []);

    if (!boxSelection) {
        const types = getBoxTypes(boxes);
        return (
            <View className={layout.vertical}>
                <ViewHeader className={classNames(layout.paddingMedium, typography.alignCenter)}>
                    <ViewTitle>
                        {t("SelectTypeTitle")}
                    </ViewTitle>
                </ViewHeader>
                <ViewContent>
                    <BoxTypeSelection onSelect={setBoxSelection} types={types} strings={t}/>
                </ViewContent>
            </View>
        );
    }
    else if (loading) {
        return <PendingView message={t("OccupyPending")}/>;
    }
    else if (error) {
        return (
            <MessageView message={t("BoxTypeNotAvailable")}>
                <PushButton onClick={handleOtherTypeClick}>
                    {t("SelectOtherSize")}
                </PushButton>
                <PushButton onClick={onDone}>
                    {t("Cancel")}
                </PushButton>
            </MessageView>
        );
    }
    else if (occupancy && box) {
        return (
            <StorageBoxAccess
                occupancy={occupancy}
                box={box}
                onDone={onDone}
                product={product}
            />
        );
    }
    return (
        <MessageView message={"Internal error"}>
            <PushButton onClick={onDone}>
                {t("Cancel")}
            </PushButton>
        </MessageView>
    );
}

